import { render, staticRenderFns } from "./checkContent.vue?vue&type=template&id=42708f38&scoped=true"
import script from "./checkContent.vue?vue&type=script&lang=js"
export * from "./checkContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42708f38",
  null
  
)

export default component.exports